export default __webpack_public_path__ + "static/media/white-close.5b0a2da2.svg";